import { combineReducers } from "redux"

import password from "./password/slice"

const profileReducer = combineReducers({
  password,
})

export default profileReducer
